import Endpoints from 'constants/Endpoints';
import { RestRequestGET } from 'libs/RestRequest';
import {clearResource, setResource} from 'redux/actions'
import reduxStore from 'redux/store'
import supportedNoApiScreens from "libs/supportedNoApiScreens";

const _get = async (url) => {
	try {
		const res = await RestRequestGET(url);
		if (res.forceRedirectOldPlatform && !supportedNoApiScreens()) {
			reduxStore.dispatch(setResource("redirectOldPlatform", true));
			window.location.replace(res.forceRedirectOldPlatform);
		} else {
			reduxStore.dispatch(
				setResource('demandHeader', res)
			);
		}
	} catch (error) {
	}
}

const get = async (id = -1) => {
	let url = Endpoints.HEADER(id)

	await _get(url)
}

const clear = () => {
	reduxStore.dispatch(clearResource('demandHeader'))
}

export default {
	get,
	clear
}
